export default __webpack_public_path__ + "static/media/newBornSelected.7214f786.svg";